module.exports = exports = window.fetch;

// Needed for TypeScript and Webpack.
exports.default = window.fetch.bind(window);

exports.Headers = window.Headers;
exports.Request = window.Request;
exports.Response = window.Response;



// WEBPACK FOOTER //
// ./node_modules/@tensorflow/tfjs-data/node_modules/node-fetch/browser.js